onComplete(function() {
	// Tabs on the car detail page; the frontend has no Bootstrap tab script.
	var tabs = document.querySelectorAll('[data-car-tab]');
	for (var t = 0; t < tabs.length; t++) {
		tabs[t].addEventListener('click', function() {
			for (var j = 0; j < tabs.length; j++) {
				var active = tabs[j] === this;
				tabs[j].classList.toggle('active', active);
				tabs[j].setAttribute('aria-selected', active ? 'true' : 'false');
				var pane = document.getElementById(tabs[j].getAttribute('data-car-tab'));
				if (pane) {
					pane.classList.toggle('active', active);
				}
			}
		});
	}
});

onComplete(function() {
	// The brand tiles in the menu link to the stock page with "#merk=<brand>". The blog filters only
	// accept a posted form, so tick that brand in the filter form and submit it.
	var match = window.location.hash.match(/^#merk=(.+)$/);
	if (!match) {
		return;
	}
	var brand = decodeURIComponent(match[1]);
	var checkboxes = document.querySelectorAll('input[name="brand[]"]');
	for (var i = 0; i < checkboxes.length; i++) {
		if (checkboxes[i].value !== brand) {
			continue;
		}
		var form = checkboxes[i].form;
		if (!form) {
			return;
		}
		history.replaceState(null, '', window.location.pathname + window.location.search);
		checkboxes[i].checked = true;
		if (form.requestSubmit) {
			form.requestSubmit();
		} else {
			form.submit();
		}
		return;
	}
});
